type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: '',
  name: 'Arcadia Viajes, Todos los Derechos Reservados',
  buyLink: '',
}

export const basePath: string = '/'
